import React, { useState, useEffect } from 'react';
import { Upload, Button, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const UploadImage = ({ setImageFiles, initialImages, multiple }) => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (initialImages && initialImages.length > 0) {
      setFileList(
        initialImages.map((image, index) => ({
          uid: index,
          name: `image-${index}`,
          status: 'done',
          url: image,
        }))
      );
    }
  }, [initialImages]);

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // Limit to only one file if multiple is not allowed
    if (!multiple) {
      fileList = fileList.slice(-1);
    }

    // Update state with the new file list
    setFileList(fileList);

    // Pass the file list to the parent component
    setImageFiles(fileList.map(file => file.originFileObj)); // Ensure originFileObj exists
  };

  const beforeUpload = (file) => {
    if (!multiple) {
      setFileList([file]);
      setImageFiles([file.originFileObj]);
    } else {
      setFileList([...fileList, file]);
      setImageFiles([...fileList, file].map(file => file.originFileObj));
    }

    return false; // Prevent default upload behavior
  };

  return (
    <Upload
      fileList={fileList}
      onChange={handleChange}
      beforeUpload={beforeUpload}
      maxCount={multiple ? undefined : 1} // Limit to only one file if multiple is not allowed
      multiple={multiple} // Enable or disable multiple file selection
      accept="image/*" // Accept only image files
      listType='picture'
    >
      <div>
        {fileList.map((file) => (
          <Image key={file.uid} src={file.url} width={200} />
        ))}
        {fileList.length === 0 && initialImages && initialImages.length > 0 && (
          <Image.PreviewGroup>
            {initialImages.map((image, index) => (
              <Image key={index} src={image} width={200} />
            ))}
          </Image.PreviewGroup>
        )}
      </div>
      <Button type="primary" className="d-flex" icon={<UploadOutlined />}>
        Select Image
      </Button>
    </Upload>
  );
};

export default UploadImage;
